<template>
    <div class="mql-bread">
        <ul>
            <li :class="{'breadcheck':index!=2}"  @click="enterpath(item,index)"
            v-for="(item,index) in levelList" :key="index">{{item.typeA}}<i v-show="index!=2">/</i></li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'MqlBread',
    data () {
        return {
        }
    },
    props:{
        levelList:{
            type:Array
        }
    },
    watch: {

    },
    created () {
        
    },
    methods: {
       enterpath (item,index) {
           if(index!=2){
             console.log(item.path)
             this.$router.push({path: item.path,query:{type:item.type}})   
           }
       }
    }
}
</script>

<style lang='scss' scoped>
li.breadcheck{color: #3696fc;cursor: pointer;}
.mql-bread{
    background-color: #f8f8f8;
    color: #97a8be;
    cursor: text;
    font-size: 14px;
    padding-left: 20px;
    line-height: 52px;
    ul{
        display: flex;
        flex-direction: row;
        li{
            i{
                font-style: normal;
                padding: 0 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/core/MqlLayout/MqlBread/index.vue